// extracted by mini-css-extract-plugin
module.exports = {"default":"idt-link_default__2dup5","icon":"idt-link_icon__3walh","danger":"idt-link_danger__388pf"};